import { IconProps, NocIconGenerator } from '../common';

export const Friends = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        css={{
            '& path': {
                strokeWidth: '1 !important',
            },
        }}
        createIconProps={{
            displayName: 'Friends',
            path: (
                <path
                    d="M7.28571 12.0412C6.5419 10.4648 4.59333 9.76424 2.9381 10.4752C1.76476 10.98 1 12.103 1 13.3291V16.0182H2.41429L2.88571 20.5H5.70381L6.17524 16.0182H7.1181M15.1429 12.0412C14.399 10.4648 12.4505 9.76424 10.7952 10.4752C9.62191 10.98 8.85714 12.103 8.85714 13.3291V16.0182H10.2714L10.7429 20.5H13.561L14.0324 16.0182H14.9752M23 12.0412C22.2562 10.4648 20.3076 9.76424 18.6524 10.4752C17.479 10.98 16.7143 12.103 16.7143 13.3291V16.0182H18.1286L18.6 20.5H21.4181L21.8895 16.0182H22.8324M1.52381 6.07576C1.52381 7.49758 2.69714 8.65151 4.14286 8.65151C5.58857 8.65151 6.7619 7.49758 6.7619 6.07576C6.7619 4.65394 5.58857 3.5 4.14286 3.5C2.69714 3.5 1.52381 4.65394 1.52381 6.07576ZM9.38095 6.07576C9.38095 7.49758 10.5543 8.65151 12 8.65151C13.4457 8.65151 14.619 7.49758 14.619 6.07576C14.619 4.65394 13.4457 3.5 12 3.5C10.5543 3.5 9.38095 4.65394 9.38095 6.07576ZM17.2381 6.07576C17.2381 7.49758 18.4114 8.65151 19.8571 8.65151C21.3029 8.65151 22.4762 7.49758 22.4762 6.07576C22.4762 4.65394 21.3029 3.5 19.8571 3.5C18.4114 3.5 17.2381 4.65394 17.2381 6.07576Z"
                    stroke="#212121"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
            ),
        }}
    />
);
